export function fieldErrorId(field: string): string {
    return `${field.replace(/\./g, '-')}-error`;
}

export function fieldProps(field: string, error?: string | undefined) {
    return {
        'data-field': field,
        'aria-invalid': Boolean(error) || undefined,
        'aria-describedby': error ? fieldErrorId(field) : undefined,
    } as const;
}

export function fieldErrorProps(field: string) {
    return {
        id: fieldErrorId(field),
        'data-error-field': field,
    } as const;
}
